global.img_url = 'http://172.31.120.58';
// global.img_url ='https://austtaa.com/server/public';